import { render } from "./StudioManager.vue?vue&type=template&id=6793340e"
import script from "./StudioManager.vue?vue&type=script&lang=js"
export * from "./StudioManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__